var signup = {
	form: {
		getSelectedCourseCount: function()
		{
			var selectedCourses = 0;
			$('.registration__courses', '#signup').find('input:checkbox:checked').each(function() {
				var $cb = $(this);
				if ($cb.attr('name').indexOf('course') === 0) {
					selectedCourses++;
				}
			});

			return selectedCourses;
		},
		getSelectedPriorities: function() {
			var selectedPriorities = [];
			$('.registration__courses', '#signup').find('select').each(function() {
				var $element = $(this);
				if ($element.attr('name').indexOf('priority') === 0) {
					var val = parseInt($element.val());
					if (val > 0) {
						if (!selectedPriorities[val]) {
							selectedPriorities[val] = 0;
						}

						selectedPriorities[val]++;
					}
				}
			});

			return selectedPriorities;
		}
	},
	validate: {
		courseCount: function(event) {
			var selectedCourses = signup.form.getSelectedCourseCount();
			if (selectedCourses === 0) {
				signup.dialog.create('Ekkert námskeið er valið.');
				return false;
			}

			if (selectedCourses > 3) {
				event.target.checked = false;
				signup.dialog.create('Aðeins er hægt að skrá sig á 3 námskeið.');
				return false;
			}
		},
		priority: function(event) {
			var selectedPriorities = signup.form.getSelectedPriorities();
			$.each(selectedPriorities, function(k, v) {
				if (v > 1) {
					$(event.target).val(0);
					signup.dialog.create('Aðeins er hægt að velja hvern forgang einu sinni.');
					return false;
				}
			});
		},
		selectedPriority: function() {
			var disabled = false;
			$('#selectedCourses').find('select').each(function() {
				var select = $(this);
				if (select.val() === '0') {
					disabled = true;
				}
			});

			$('#signupSubmit').attr('disabled', disabled);
		},
	},

	dialog: {
		create: function(message) {
			if ($('#signup__dialog').length) {
				signup.dialog.destroy();
			}

			$('body').append('<div id="signup__dialog"><div class="dialog__message">'+message+'</div></div>');
			signup.dialog.show();
		},
		destroy: function() {
			$('#signup__dialog').remove();
		},
		show: function() {
			$( "#signup__dialog" ).dialog({
				modal: true,
				buttons: {
					Ok: function() {
						$( this ).dialog( "close" );
					}
				}
			});
		}
	}
};

$(function() {
	$('.registration__courses', '#signup').find('input:checkbox,select').on('change', function(event) {
		signup.validate.courseCount(event);
		signup.validate.priority(event);
		signup.validate.selectedPriority();
	})

	$('#registration__form').on('submit', function(e) {
		$('#signupSubmit').attr('disabled', true);
	});

	signup.validate.selectedPriority();
});
